import {
  addDoc,
  collection,
  getDocs,
  query,
  serverTimestamp,
  where,
} from 'firebase/firestore';
import { auth, db } from './firebase';

const normaliseText = (value) => String(value || '').trim();
const updateTypes = new Set(['Record', 'Availability', 'Utilisation', 'Inspection', 'Maintenance']);
const statusCodes = new Set(['R', 'O', 'G']);

const normaliseUpdateType = (value) => {
  const updateType = normaliseText(value);
  return updateTypes.has(updateType) ? updateType : 'Record';
};

const normaliseStatus = (value) => {
  const status = normaliseText(value).toUpperCase();
  return statusCodes.has(status) ? status : '';
};

const serialiseUpdate = (snapshot) => {
  const data = snapshot.data();
  return {
    id: snapshot.id,
    ...data,
    createdAt: data.createdAt?.toDate ? data.createdAt.toDate().toISOString() : data.createdAt,
  };
};

export const registerUpdateService = {
  async listUpdatesForLink(linkId) {
    if (!linkId) return [];

    const snapshot = await getDocs(query(
      collection(db, 'sharabl-register-updates'),
      where('linkId', '==', linkId),
    ));

    return snapshot.docs
      .map(serialiseUpdate)
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
  },

  async listUpdates(linkId, assetId) {
    if (!linkId || !assetId) return [];

    const snapshot = await getDocs(query(
      collection(db, 'sharabl-register-updates'),
      where('linkId', '==', linkId),
      where('assetId', '==', assetId),
    ));

    return snapshot.docs
      .map(serialiseUpdate)
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
  },

  async addUpdate(link, asset, data = {}) {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('You must be signed in to add register updates.');
    }

    const message = normaliseText(data.message);
    if (!message) {
      throw new Error('Enter an update before submitting.');
    }

    if (!link?.id || !asset?.id) {
      throw new Error('This register item is missing a saved link reference.');
    }

    const payload = {
      linkId: link.id,
      linkSlug: link.slug || '',
      linkTitle: link.title || '',
      assetId: asset.id,
      assetTitle: asset.title || asset.name || 'Untitled register item',
      ownerId: link.ownerId || '',
      authorId: user.uid,
      authorEmail: user.email || '',
      authorName: user.displayName || user.email || 'Signed-in user',
      updateType: normaliseUpdateType(data.updateType),
      dateTime: normaliseText(data.dateTime),
      quantity: normaliseText(data.quantity),
      message,
      status: normaliseStatus(data.status),
      accessShareId: normaliseText(data.accessShareId),
      createdAt: serverTimestamp(),
    };

    const created = await addDoc(collection(db, 'sharabl-register-updates'), payload);
    return {
      ...payload,
      id: created.id,
      createdAt: new Date().toISOString(),
    };
  },
};
